import styled, { css } from 'styled-components'
import media from 'styled-media-query'

type ModalDialogContentProps = {
  width?: string
  height?: string
}

export const ModalDialogOverlay = styled.div`
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
`

export const ModalDialogContent = styled.div<ModalDialogContentProps>`
  ${({ theme, width = '60%', height = 'auto' }) => css`
    position: fixed;
    width: ${width};
    height: ${height};
    overflow-y: scroll;
    background: ${theme.colors.white};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    border-radius: 5px;
    box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.08);
    padding: 35px;

    .validate-report-modal {
      h3 {
        font-size: ${theme.font.sizes.normal};
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.xbold};
        margin-bottom: 10px;
        margin-top: -14px;
      }

      .warnings-container {
        display: flex;
        flex-direction: column;
        font-size: ${theme.font.sizes.normal};
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.xbold};
        padding: 16px 0;

        > a {
          font-size: ${theme.font.sizes.xxxsmall};
          font-family: ${theme.font.comfortaa};
          font-weight: ${theme.font.xbold};
          padding: 4px 24px;
          text-decoration: none;
          color: ${theme.colors.darkGray};
          margin: 0;
          transition: color ${theme.transition.default};

          &:hover {
            color: ${theme.colors.primary};
          }
        }
      }

      .buttons-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 24px;

        > button {
          width: 50%;
        }

        .access-complete-register-button {
          margin-top: 18px;
          width: 26%;
          background: none;
          border: none;
          font-size: ${theme.font.sizes.normal};
          cursor: pointer;

          a {
            color: ${theme.colors.darkGray};
            text-decoration: none;
            transition: color ${theme.transition.default};

            &:hover {
              color: ${theme.colors.primary};
            }
          }
        }
      }
    }

    .delete-modal {
      > p {
        text-align: center;
        font-size: ${theme.font.sizes.normal};
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.normal};
      }

      .attention-label {
        color: ${theme.colors.red};
        font-weight: ${theme.font.xbold};
      }

      > div {
        display: flex;
        margin-top: 24px;
        gap: 28px;
      }
    }

    .instructions-modal {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: -18px 0;

      > p {
        text-align: center;
        font-size: ${theme.font.sizes.xxsmall};
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.normal};
      }

      > button {
        margin: 20px 0;
        max-width: 280px;
      }
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }

    ${media.lessThan('medium')`
      width: 80%;
      transform: translate(-50%, -50%);
    `}

    ${media.lessThan('small')`
      padding: 12px;
      width: 95vw;
      overflow-x: auto;
    `}
  `}
`

export const ModalDialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
`

export const ModalDialogHeaderTitle = styled.h3`
  ${({ theme }) => css`
    line-height: 26px;
    font-size: ${theme.font.sizes.medium};
    font-family: ${theme.font.comfortaa};
    font-weight: ${theme.font.normal};
    padding: 0;
    margin: 0 6px 0 0;
    color: ${theme.colors.primary};
    font-weight: bold;
  `}
`

export const ModalDialogClose = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 15px;
    color: ${theme.colors.white};
    font-size: 22px;
    width: 30px;
    height: 30px;
    text-align: center;
    background: ${theme.colors.black};
    border-radius: 50%;
    transition: filter ${theme.transition.default};

    &:hover {
      filter: brightness(0.8);
    }
  `}
`

export const ModalDialogBody = styled.div`
  padding: 0;
  overflow-y: auto;
  max-height: 80vh;
  padding-bottom: 1em;
`

export const ModalDialogFooter = styled.div``
